import {combineReducers} from "redux";
import {Action} from "redux-actions";
import {ActiveModalState} from "../../_definitions/styleteq";
import {toggleActiveModal} from "./actions";


function activeModalKey(state: string = null, action: Action<ActiveModalState>) {

    switch (action.type) {
        case toggleActiveModal.toString():
            return action.payload.key;
    }

    return state;
}

function activeModalFlag(state: boolean = false, action: Action<ActiveModalState>) {

    switch (action.type) {
        case toggleActiveModal.toString():
            return action.payload.active;
    }
    return state;
}

const activeModalReducer = combineReducers({
    key: activeModalKey,
    active: activeModalFlag
});

export default activeModalReducer;




// WEBPACK FOOTER //
// ./app/client/_widgets/modal/reducer.ts